import {useEffect, useState, useRef} from "react";
import {Websocket} from "../services/Websocket";
import * as signalR from "@microsoft/signalr";
import {Snackbar} from "../components/Snackbar";

export const useSignalR = (selectedCheck, setSelectedCheck, setLockedCheckIdArray) => {
    const [connectionId, setConnectionId] = useState(null);
    const isMounted = useRef(true);

    useEffect(() => {
        setupWebSocketListeners();
        return () => {
            isMounted.current = false;
            Websocket.Client?.stop();
        };
    }, []);

    useEffect(() => {
        if (selectedCheck?.checkID && Websocket.Client?.state === signalR.HubConnectionState.Connected) {
            emitLockElement(selectedCheck.checkID);
        }
    }, [selectedCheck?.checkID, Websocket.Client?.state]);

    const setupWebSocketListeners = () => {
        Websocket.setupClient();
        if (Websocket.Client.state !== signalR.HubConnectionState.Connected) {
            try {
                Websocket.Client.start();
            } catch (e) {
                console.error(e);
            }
        }

        Websocket.Client.on('lockedElements', (data) => {
            try {
                const lockedElements = Object.values(data).filter((lock) => lock.lockedById !== Websocket.Client.connectionId);
                setLockedCheckIdArray(lockedElements);
            } catch (e) {
                console.error("Error parsing locked elements: ", e);
            }
        });

        Websocket.Client.on('connected', () => {
            console.log("Socket connected:" + Websocket.Client.connectionId);
            setConnectionId(Websocket.Client.connectionId);
            if (isMounted.current) {
                Snackbar({message: "Client connected.", variant: "success"});
            }
            Websocket.Client.invoke('getLockedElements');
            if (selectedCheck?.checkID) {
                emitLockElement(selectedCheck.checkID);
            }
        });

        Websocket.Client.onclose((error) => {
            console.log("Socket disconnected:" + Websocket.Client.connectionId);
            setConnectionId(null);
            if (isMounted.current) {
                Snackbar({message: "Client disconnected.", variant: "error"});
            }
            if (error) {
                console.log("Disconnect with error: ", error);
            }
            setLockedCheckIdArray([]);
            selectedCheck.locked = false;
        });

        Websocket.Client.onreconnecting(() => {
            console.log("Socket reconnecting...");
            setConnectionId(null);
            if (isMounted.current) {
                Snackbar({message: "Client reconnecting...", variant: "warning"});
            }
        });

        Websocket.Client.onreconnected(() => {
            console.log("Socket re-connected:" + Websocket.Client.connectionId);
            setConnectionId(Websocket.Client.connectionId);
            if (selectedCheck?.checkID) {
                emitLockElement(selectedCheck.checkID);
            }
            Websocket.Client.invoke('getLockedElements');
        });
    };

    const emitLockElement = (checkID) => {
        try {
            Websocket.Client?.invoke('changeLockedElement', {
                checkID: checkID,
                lockedById: Websocket.Client.connectionId,
            });
        } catch (e) {
            console.error("Error invoking lock element: ", e);
        }
    };

    return {connectionId, emitLockElement};
};